import { BitrixVue } from 'ui.vue';

BitrixVue.component('ConfigBlock', {
	template: `
		<div class="config-block">
			<slot></slot>
		</div>
`,
});
